import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { AgentDetailSchema } from "../types";

export function useAgent(agentId: string) {
  return useQuery({
    queryKey: ["agent", agentId],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(`/api/v1/agents/${agentId}`);
      return AgentDetailSchema.parse(data);
    },
    enabled: !!agentId,
    staleTime: 5 * 60 * 1000,
  });
}
